import {useState} from 'react';

import mwConnectionService from '@/services/mw/mwConnectionService';
import appRouterService from '@/services/route/appRouterService';

import useConnectionGuidePageContent from './useConnectionGuidePageContent';

const useConnectionGuide = () => {
    const {deviceType, contentItems} = useConnectionGuidePageContent();
    const [currentStep, setCurrentStep] = useState(0);

    const handleNextStep = () => {
        if (currentStep < contentItems.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            mwConnectionService.initDeviceConnection({
                onConnect: () => {
                    appRouterService.forwardToConnectPage(deviceType, true);
                },
            });
        }
    };

    return {contentItems, currentStep, deviceType, handleNextStep};
};

export default useConnectionGuide;
